<template>
  <div class="focus-area-links">
    <a href>
      Helping British farmers
      <BaseIcon name="arrow_forward" size="18"></BaseIcon>
    </a>
    <a href>
      Look after our colleagues
      <BaseIcon name="arrow_forward" size="18"></BaseIcon>
    </a>
    <a href>
      Safety, quality and provenance
      <BaseIcon name="arrow_forward" size="18"></BaseIcon>
    </a>
    <a href>
      Source responsibility
      <BaseIcon name="arrow_forward" size="18"></BaseIcon>
    </a>
    <a href>
      Reducing plasic waste
      <BaseIcon name="arrow_forward" size="18"></BaseIcon>
    </a>
    <a href>
      Supplier working conditions
      <BaseIcon name="arrow_forward" size="18"></BaseIcon>
    </a>
    <a href>
      Reduce waste and emissions
      <BaseIcon name="arrow_forward" size="18"></BaseIcon>
    </a>
    <a href>
      Healthy customers
      <BaseIcon name="arrow_forward" size="18"></BaseIcon>
    </a>
    <a href>
      Reduce food waste
      <BaseIcon name="arrow_forward" size="18"></BaseIcon>
    </a>
    <a href>
      Supporting local communities
      <BaseIcon name="arrow_forward" size="18"></BaseIcon>
    </a>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
export default {
  name: 'FocusAreaLinks',
  components: { BaseIcon }
}
</script>

<style lang="postcss">
.focus-area-links {
  @apply flex flex-wrap pl-6;
}
.focus-area-links a {
  @apply text-white w-full block flex items-center justify-between mb-3;
}
.focus-area-links a:hover {
  @apply opacity-50;
}
@screen sm {
  .focus-area-links a {
    @apply w-1/2;
  }
}
@screen md {
  .focus-area-links {
    @apply pl-0;
  }
  .focus-area-links a {
    @apply w-full;
  }
}
@screen lg {
  .focus-area-links a {
    @apply w-1/2;
  }
  .focus-area-links a:nth-child(odd) {
    @apply pr-6;
  }
}
</style>

